import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import WordCloud from "../../../../../Component/Charts/WordCloud";

const ChecksByCountry = (props) => {
  const { data } = props;

  const { t } = useTranslation();

  const [countryValues, setCountryValues] = useState([]);

  useEffect(() => {
    setCountryValues((data || []).map((val) => ({
      name: val["country_name"],
      value: val["no_of_checks"],
    })));
  }, [data]);

  return (
    <WordCloud words={countryValues} title={t("labels.dashboard.checksByCountry.title")} />
  );
};

export default ChecksByCountry;
